import React, { useContext, useState, useEffect } from 'react';
import { Timestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import {
  Space,
  Avatar,
  Row,
  Col,
  Collapse,
  Button,
  List,
  Timeline,
  message,
  Tabs,
  Input,
  Card,
  Divider,
} from 'antd';
import { useIntl } from 'react-intl';
import {
  CloseOutlined,
  CheckOutlined,
  UserAddOutlined,
  RetweetOutlined,
  SendOutlined,
} from '@ant-design/icons';
import { StoreContext } from '../store/index';
import { updateShift, addFriend } from '../shifts/api';
import { getDateFromTimestamp } from '../utils';
import TshirtIcon from '../components/tshirtIcon';
import PlayersList from '../components/PlayersList';

const TeamsTab = ({ league }) => {
  const { formatMessage } = useIntl();
  const store = useContext(StoreContext);
  const {
    user: [user, setUser, setUpdateUser],
  } = store;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  return (
    <Row justify="space-between" className="width100">
      <Collapse
        key="teams"
        className="width100"
        style={{ marginTop: '2px' }}
        bordered={false}
        defaultActiveKey={[]}
        items={[
          {
            key: league.id,
            label: '',
            children: (
              <List
                size="small"
                itemLayout="vertical"
                loading={loading}
                defaultactivekey={['playersPanel']}
                dataSource={[]}
                header={<Row justify="space-between">aa</Row>}
                renderItem={player => (
                  <List.Item
                    style={{ padding: '0px', marginTop: '8px', border: 'none' }}
                    key={player.id}>
                    <Row
                      justify="center"
                      style={{
                        marginBottom: '8px',
                      }}>
                      caca
                    </Row>
                  </List.Item>
                )}
              />
            ),
          },
        ]}
      />
    </Row>
  );
};
export default TeamsTab;
